import React, { Component } from "react";
import { Route, Switch, Link } from "react-router-dom";
import { connect } from 'react-redux';
import Box from "../../components/Box";
import Chart from "../../components/Chart";
import ListData from "../../components/ListData";
import TableData from "../../components/TableData";
import DatePicker from "../../components/DatePicker";
import MultiSelect from "../../components/MultiSelect";
import LoadingModal from "../../components/LoadingModal";
import "./styles.css";
import BoxChart from "../../components/BoxChart";
import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Button,
  Divider,
  Label,
  Table,
  Tab,
  Icon,
  Modal
} from "semantic-ui-react";
import moment from "moment";
import "./styles.css";
import ProductAnalyticsModal from './productAnalyticsModal';

const barChartTemplate = {
  chart: {
    backgroundColor: "none",
    marginLeft: 45,
    height: 155,
    fontFamily: "Roboto",
    fontWeight: 400,
    spacingTop: 10,
    type: "line",
    style: {
      paddingBottom: 10,
      fontSize: 16
    }
  },
  title: {
    useHTML: true,
    style: {
      color: "#414042",
      fontSize: 16,
      fontWeight: 400,
      fontFamily: "Roboto"
    },
    text: null,
    align: "left",
    x: -5,
    y: 5
  },
  xAxis: {
    categories: [],
    labels: {
      style: {
        fontSize: "8px"
      }
    }
  },
  yAxis: [
    {
      title: {
        text: null
      }
    }
  ],
  legend: {
    itemStyle: {
      fontWeight: "400",
      fontSize: "13px",
      fontFamily: "Roboto",
      color: "#414042"
    }
  },
  labels: {
    items: []
  },
  series: [],
  credits: {
    enabled: false
  }
};




class ProductAnalytics extends Component {
  onLogout() {
    this.props.authOnLogout();
  }
  constructor(props) {
    super(props);

    this.state = { value: "all", showModal: false,inventory_details_data: null  };
  }

  showProductDetailsModal = (inventory_details_data) => {
    this.setState({
      showModal: true,
      inventory_details_data

    })
  }

  hideProductDetailsModal = () => {
    this.setState({
      showModal: false
    })
  }
  render() {
    const secondary_yAxis = {
      gridLineWidth: 0,
      title: {
        text: null
      },
      opposite: true
    };
    let { product_analytics } = this.props;
    let {inventory_details_data, showModal } =this.state;
    return (
      <div>
        <div>
          <Grid.Row style={{ float: "right", marginRight: 15 }}>
            <Grid.Column>
              <MultiSelect />
            </Grid.Column>
            <Grid.Column>
              <div style={styles.datePicker}>
                <DatePicker />
              </div>
            </Grid.Column>
          </Grid.Row>
        </div>
        {product_analytics.map((data, index) => {
          const inventoryChart = JSON.parse(JSON.stringify(barChartTemplate));
          inventoryChart["xAxis"]["categories"] = data.inventory_chart["categories"];
          inventoryChart["series"] = data.inventory_chart["series"]
          inventoryChart["yAxis"].push(secondary_yAxis);
          inventoryChart.series[0].showInLegend = false
          inventoryChart.series[1].showInLegend = false
          return (
            <div className="innersection" style={{ clear: "both", }} key={index}>
              <Header style={styles.mainHeadig} as="h3">
                LOCATION: {data.location}
              </Header>
              <Grid columns={3}>
                <Box componentData={data.coverage} percent={true} />
                <Box componentData={data.po_inventory_value} />
                <BoxChart data={inventoryChart}
                  inventory_details_data={data.inventory_details}
                  header={"Inventory Trends"}
                  showProductDetailsModal={this.showProductDetailsModal}
                />
              </Grid>

            </div>
          )
        })
        }
        {showModal ?
        <ProductAnalyticsModal showModal={showModal}
          hideProductDetailsModal={this.hideProductDetailsModal}
          inventory_details_data={inventory_details_data}
        />
        : null}

      </div>

    )
  }
}

const styles = {
  headingText: {
    fontSize: 16,
    color: "#666874",
    marginTop: 20,
    marginBottom: 15,
    paddingBottom: 18,
    paddingLeft: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#c1c1c5"
  },
  comingSoon: {
    backgroundColor: "#59d345",
    color: "#fff",
    fontFamily: "Roboto",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 15,
    paddingRight: 15
  },
  dropDown: {
    fontFamily: "Roboto",
    borderRadius: 20,
    color: "rgb(102, 104, 116)",
    marginRight: 50,
    position: "relative",
    top: 52,
    backgroundColor: "transparent",
    fontSize: 14,
    fontWeight: 300
  },
  customClass: {
    backgroundColor: "transparent",
    color: "rgb(102, 104, 116)",
    fontSize: 14,
    fontWeight: 300
  },
  topHeader: {
    backgroundColor: "#652d92",
    color: "white"
  },
  mainHeadig: {
    marginTop: 30,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#666874",
    paddingTop: 40
  },
  title: {
    padding: 10,
    fontSize: 22
  },
  sideBar: {
    top: 45,
    backgroundColor: "#2c2435"
  },
  datePicker: {
    paddingTop: 20,
    paddingRight: 20,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 400
  },

  mainTable: {
    borderWidth: 0,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "transparent"
  },
  tablerow: {
    textAlign: "center",
    fontFamily: "Roboto",
    backgroundColor: "none"
  },
  hederCell: {
    backgroundColor: "#ECF3FA",
    color: "#999",
    fontSize: 14,
    fontWeight: 300,
    paddingTop: 15,
    paddingBottom: 15,
    borderColor: "#c1c1c5",
    borderWidth: 0.7,
    borderRadius: 0
  },
  tableCellfirst: {
    backgroundColor: "#F9F9FE",
    color: "#999",
    fontSize: 14,
    paddingTop: 15,
    paddingBottom: 15,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  tableCell: {
    backgroundColor: "#F9F9FE",
    color: "#313131",
    fontSize: 14,
    paddingTop: 25,
    paddingBottom: 25,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  headerRow: {
    textAlign: "center",
    fontFamily: "Roboto"
  },
  heading: {
    fontSize: 16,
    color: "rgb(102, 104, 116)",
    paddingBottom: 10,
    paddingLeft: 15,
    paddingTop: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto"
  }
};




export default connect(state => {
  return {
    product_analytics: state.product_analytics
  }
})(ProductAnalytics);



// WEBPACK FOOTER //
// ./src/components/TabSales/productAnalytics.js